<mat-card-subtitle style="margin-top: 16px;">
  {{containerDesc}}
</mat-card-subtitle>

<form class="dynamic-form" [formGroup]="form" style="width: 100%">
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

    <mat-form-field fxFlex="70" width="100%">
      <mat-label>TFG Card Number</mat-label>
      <input matInput style="text-align: left;" type="text" min="19" max="19" formControlName="tfgCardNumber" autocomplete="new-password" (keyup.enter)="checkForTfgCardScan($event, $event.target.value)">
    </mat-form-field>

    <div fxFlex="15" width="100%">
      <button [disabled]="!form.value.tfgCardNumber || form.value.tfgCardNumber.length !== 19 || tfgAccountDetails" mat-raised-button color="primary" (click)="validate()">Validate</button>
    </div>
    <div fxFlex="15" width="100%">
      <button [disabled]="!tfgAccountDetails" mat-raised-button color="warn" (click)="resetValidation()">Reset</button>
    </div>

    <ng-container *ngIf="tfgAccountDetails">

      <mat-form-field fxFlex="25" width="100%">
        <mat-label>TFG Account Holder</mat-label>
        <input matInput style="text-align: left;" type="text"  min="19" max="19" formControlName="accountHolder" autocomplete="new-password">
      </mat-form-field>

      <mat-form-field fxFlex="25" width="100%">
        <mat-label>OTB Balance</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="otbBalance">
      </mat-form-field>

      <ng-container *ngIf="paymentType && (paymentType === 'REFUND' || paymentType === 'DEPOSIT-REFUND'); else noCreditOrRefund">
        <mat-form-field fxFlex="50" width="100%">
          <mat-label>Credit Plan</mat-label>
          <mat-select [disabled]="paymentType && (paymentType === 'REFUND' || paymentType === 'DEPOSIT-REFUND')" formControlName="creditPlan">
            <mat-option *ngFor="let plan of tfgAccountDetails.creditPlans" [value]="plan.creditPlan">
              {{plan.creditPlan}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </ng-container>
      <ng-template #noCreditOrRefund>
        <div fxFlex="20">
          <button mat-raised-button color="primary" (click)="payAccount('DEPOSIT')">Increase OTB</button>
        </div>

        <mat-form-field fxFlex="30" width="100%">
          <mat-label>Credit Plan</mat-label>
          <mat-select [disabled]="paymentType && (paymentType === 'REFUND' || paymentType === 'DEPOSIT-REFUND')" formControlName="creditPlan">
            <mat-option *ngFor="let plan of tfgAccountDetails.creditPlans" [value]="plan.creditPlan">
              {{plan.creditPlan}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>


      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Amount Tendered</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="amountTendered" autocomplete="new-password"
          (keyup)="amountTenderedChanged()" (focusout)="amountTenderedFocusOut()">
      </mat-form-field>

      <mat-form-field fxFlex="40" width="100%">
        <mat-label>Minus Outstanding</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="amountOutstanding">
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Equals Unpaid</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="amountDifference">
      </mat-form-field>
    </ng-container>
  </div>
</form>
